<template>
    <div class="wrapper">
        <div class="tit">
            <h1>Lista de entradas</h1>
        </div>

        <div class="ctn_general">
            <div class="tabla_ctn">
                <div class="tabla_filtros">

                    <Filters :data="filterData" label="Filtrar entradas" @onFilter="onFilter"/>

                    <div class="tfiltros_col xs right mOrder1 nowrap">
                        <a @click="reload" class="btn_icon mdi mdi-reload tool">
                            <span class="tooltip bottom left">Actualizar</span>
                        </a>
                        <div class="mdi mdi-magnify input_search mobileOrder3">
                            <form @submit.prevent="searchByKeyword">
                                <input type="search"
                                       placeholder="Buscar por Título, URL, Descripción, Etiqueta o Creador"
                                       v-model="keyword">
                            </form>
                        </div>
                        <div class="mobileOrder2">
                            <router-link tag="a" class="btn"
                                         :to="{name:'article-creator'}">
                                Agregar entrada
                            </router-link>
                        </div>
                    </div>
                </div>

                <div class="tabla_scroll">
                    <table class="lProducto con_options">
                        <thead>
                        <tr>
                            <th>Título</th>
                            <th>Link</th>
                            <th>Etiquetas</th>
                            <th>Creado por</th>
                            <th>Fecha de creación</th>
                            <th>Fecha de actualización</th>
                            <th>Estado</th>
                            <th class="d_option"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="article in articles">
                            <td>
                                <router-link :to="{name: 'article-editor', params: {slug: article.slug}}">
                                    {{ article.title }}
                                </router-link>
                            </td>
                            <td style="text-align: center;">
                                <a :href="`${frontEndUrl}/${article.slug}`" target="_blank"><i
                                    class="mdi mdi-open-in-new"></i></a>
                            </td>
                            <td>
                                <span v-for="(tag, tagIndex) in article.tags"
                                      v-text="tagIndex === article.tags.length - 1 ? tag : tag + ', '"></span>
                            </td>
                            <td style="text-align: center;">{{ article.createdBy }}</td>
                            <td style="text-align: center;">{{ getFormatDate(article.createdAt) }}</td>
                            <td style="text-align: center;">
                                {{ article.updatedAt ? getFormatDate(article.updatedAt) : '' }}
                            </td>
                            <td style="text-align: center;">
                                <span
                                    :class="`budget ${getStatusStr(article.active).color}`">{{
                                        getStatusStr(article.active).value
                                    }}</span>
                            </td>
                            <td class="d_option">
                                <i class="mdi mdi-dots-vertical"></i>
                                <span class="drop_options estados_pedido">
                                    <span @click="goToEdit(article.slug)">Editar</span>
									<span @click="changeArticleStatus(article._id, article.active)">
                                        {{ article.active ? 'Supender' : 'Activar' }}
                                    </span>
                                    <span @click="deleteArticle(article._id)">Eliminar</span>
								</span>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <Paginator :total="total" :page="page" :page-size="pageSize" :pages="pages" :changePage="changePage"
                           :changePageSize="changePageSize"/>
            </div>
        </div>
    </div>
</template>
<script>

import * as moment from 'moment';
import ArticleService from "../../services/ArticleService";
import {loading} from '../../util/util'
import alert from '../../util/alert'
import {paginatorMixin} from '../../util/paginatorMixin'
import Filters from '../common/Filters.vue'
import {AdminConstants} from '../../constants'

export default {
    components: {
        Filters
    },
    data() {
        return {
            articles: [],
            keyword: null,
            filters: [],
            filterData: [
                {key: 'status', label: 'Estado', type: 'multiple', items: AdminConstants.ARTICLE_STATUS},
                {key: 'createdAt', label: 'Fecha de creación', type: 'date'},
                {key: 'updatedAt', label: 'Fecha de actualización', type: 'date'},
            ],
            adsType: AdminConstants.ADS_TYPE,
            frontEndUrl: process.env.FRONTEND_URL
        }
    },
    mixins: [paginatorMixin],
    computed: {
        categoriesOnFilters() {
            return this.categories.map((category) => {
                return {id: category._id, key: category.key, value: category.label, useId: true}
            })
        }
    },
    methods: {
        getStatusStr(status) {
            if (status === true) {
                return AdminConstants.ARTICLE_STATUS[0]
            }

            return AdminConstants.ARTICLE_STATUS[1]
        },
        changePage(p) {
            const self = this;
            self.page = p;
            self.listArticles(p, self.pageSize)
        },
        changePageSize(pageSize) {
            const self = this;
            this.page = 1;
            this.pageSize = pageSize;
            self.listArticles(this.page, pageSize)
        },
        downloadExcel() {
        },
        async listArticles(page, pageSize) {
            loading(true);
            const self = this;
            const params = {page: page, size: pageSize};
            if (self.keyword)
                params.keyword = self.keyword;

            if (self.filters && self.filters.length > 0) {
                self.filters.forEach(it => {
                    let opts;
                    if (it.data instanceof Array) {
                        opts = [];
                        it.data.forEach(o => {
                            if (o.useId === true) {
                                opts.push(o.id);
                            } else {
                                opts.push(o.key);
                            }
                        })
                    } else if (it.data.startDate || it.data.endDate) {
                        opts = [];
                        if (it.data.startDate)
                            opts.push(it.data.startDate.format('YYYY-MM-DD'));
                        if (it.data.endDate)
                            opts.push(it.data.endDate.format('YYYY-MM-DD'))
                    } else {
                        opts = it.data.key;
                    }
                    params[it.key] = opts;
                })
            }

            const resp = (await ArticleService.get(params)).data.payload;
            self.articles = resp.content;
            self.total = resp.totalElements;
            self.pages = resp.totalPages;
            loading(false);
        },
        searchByKeyword() {
            const self = this;
            self.page = 1;
            self.listArticles(self.page, self.pageSize);
        },
        edit(prod) {
            this.$router.push({name: 'product-editor', params: {productId: prod.id}});
        },
        onFilter(data) {
            const self = this;
            self.filters = data;
            self.page = 1;
            self.listArticles(self.page, self.pageSize);

        },
        getFormatDate(date) {
            return moment(date).format('DD/MM/YYYY')
        },
        goToEdit(slug) {
            this.$router.push({name: 'article-editor', params: {slug: slug}});
        },
        changeArticleStatus(articleId, active) {
            const self = this;
            const actionText = active ? AdminConstants.ARTICLE_STATUS[1].actionName : AdminConstants.ARTICLE_STATUS[0].actionName
            alert.dialog(`¿Estás seguro que deseas ${actionText} la entrada?`,
                null,
                async function () {
                    try {
                        loading(true);

                        self.listArticles(self.page, self.pageSize);
                        const resp = (await ArticleService.updateStatus(articleId, {active: !active})).data.payload;

                        if (resp) {
                            self.listArticles(self.page, self.pageSize);
                        }

                        alert.success("Estado de la entrada actualizado correctamente.");
                    } catch (e) {
                        console.error(e);
                        alert.error("Error actualizando estado del Artículo")
                    } finally {
                        loading(false);
                    }
                });
        },
        deleteArticle(articleId) {
            const self = this;
            alert.dialog(`¿Estás seguro que deseas eliminar el artículo?`,
                null,
                async function () {
                    try {
                        loading(true);
                        const resp = (await ArticleService.delete(articleId))
                        self.listArticles(self.page, self.pageSize);
                        alert.success("Artículo eliminado.");
                    } catch (e) {
                        console.error(e);
                        alert.error("Error al eliminar el artículo")
                    } finally {
                        loading(false);
                    }
                });
        },
        fetchCategories() {
            const self = this;
            if (self.categories && self.categories.length > 0) {
                const cats = [{id: null, value: 'Sin categoría'}];
                cats.push.apply(cats, self.categoriesOnFilters);
                const categoryFilter = {
                    key: 'categories',
                    label: 'Categorías',
                    type: 'multiple', items:
                    cats
                };
                self.filterData.push(categoryFilter)
            } else {
                setTimeout(() => {
                    self.fetchCategories();
                }, 300)
            }

        },
        getTypeStr(type) {
            if (type) {
                const typeFound = AdminConstants.ARTICLE_TYPE.find((o) => o.id === type);
                if (typeFound)
                    return typeFound.value;
            }
            return '-'

        },
        reload() {
            this.listArticles(this.page, this.pageSize);
        },
    },
    mounted() {
        this.fetchCategories();
        const self = this;
        self.listArticles(this.page, this.pageSize);
    }
}
</script>



// WEBPACK FOOTER //
// src/components/articles/Articles.vue